import { styled } from '@mui/material/styles';

export const StyledTextArea = styled('textarea')`
  margin-top: 10px;
  resize: none;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
`;
